/**
 * Legacy org-less `/connections`: Plugins & Skills now live under the
 * organization (`/$org/connections`). A session with a known org is sent
 * there; with nothing to scope to, home.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

export const Route = createFileRoute("/connections")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
    const lastPickedOrgId = readLastPickedOrgId();
    if (!lastPickedOrgId) {
      throw redirect({ to: "/", replace: true });
    }
    throw redirect({
      to: "/$org/connections",
      params: { org: orgUrlSegment(lastPickedOrgId) },
      replace: true,
    });
  },
});
